import React from 'react';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ComponentInfo } from '@components';
import { Box, Spacer, Typography, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { Anything } from '@types';

export const CloudwareDisclaimerDocumentPlaceholder: React.FC = () => {
	const t = useTranslation();
	const { palette } = useTheme();
	return (
		<ComponentInfo name="CloudwareDisclaimerDocumentPlaceholder">
			<Box styles={{ marginTop: rem(16), flexDirection: 'column' }}>
				<Typography
					appearance="body-75-02"
					alternativeStyleProperties={{ color: palette.global.ui9 } as Anything}
				>
					{t('placeholders.cloudware.disclaimer.firstParagraph')}
				</Typography>
				<Spacer vertical={rem(12)} />
				<Typography
					appearance="body-75-02"
					alternativeStyleProperties={{ color: palette.global.ui9 } as Anything}
				>
					{t('placeholders.cloudware.disclaimer.secondParagraph')}
				</Typography>
			</Box>
		</ComponentInfo>
	);
};
